import { lazy } from 'react';
import { retry } from '../../../../config/utils';

const AccountBalance = lazy(() => retry(()=> import(/* webpackChunkName: "PartnerUploadLoan" */ "./index")));

export default AccountBalance;